import React,{useState,useEffect} from 'react'
import { Modal,Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { removePrivateTalentInit } from '../../../../redux/actions';
import TopAlert from '../../../../components/TopNotification/TopAlert';
import "./PopupModal.css"

const PopupModal = ({show,onClose,id,popUpTrue,setpopUpTrue=()=>{}}) => {
  const dispatch = useDispatch();
  // const [userProfileState, setuserProfileState] = useState(userProfile);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const Pdetails = useSelector(
    (state) => state.getProfileDetailsReducer.details
  );
  const removePvtLoading = useSelector(
    (state) => state.getProfileDetailsReducer.loadingPrivate
  );

  const handleOk = () => {
    dispatch(removePrivateTalentInit(id)); 
    setpopUpTrue(true)
    onClose()
  };
  

  const handleCancel = () => {
    onClose();
  };
  // open={show} onOk={handleOk} onCancel={handleCancel}
  return (
   <div>
     <Modal title={<div className='removeMsg'>Remove candidate from private marketplace?</div>}
    onCancel={handleCancel}
    open={show}
    footer={[
      <Button key="back" className='backBtn' onClick={handleCancel} >
        No
      </Button>,
      <Button key="submit" className='submitBtn' type="primary" onClick={handleOk}>
        Yes
      </Button>,
    ]}>
        <p className='msg'>Are you sure you want to remove this candidate from private marketplace?
        Candidate will lose the private tag and will no longer be able to see your private gigs.</p>
    </Modal>
    {popUpTrue && !removePvtLoading ? <TopAlert
                    display={"flex"}
                    title={"Candidate removed from private marketplace"}
                    type={"success"}
                  /> : ""
    }
   </div>
  )
}

export default PopupModal